const enum NoCollectiblesType {
  Collectibles = 'collectibles',
  Transactions = 'transactions',
  Filters = 'filters',
}

export default NoCollectiblesType;
